@if (heading) {
  <div class="nav-item__context-header">{{ heading }}</div>
}

@if (content) {
  <ng-container [ngTemplateOutlet]="content"></ng-container>
}

@if (description) {
  <div
    class="font-xs text-muted text-truncate"
    [portalTippy]="description"
    [showIfTruncated]="true"
    appendTo="body"
  >
    {{ description }}
  </div>
}

<ng-template [portalTransclusion]="transclusions" portalTransclusionName="afterDescription"></ng-template>
